export default {"src":"/_next/static/media/advantage-bg.66c54711.svg","height":1839,"width":272,"blurWidth":0,"blurHeight":0};